import { Navigate, Outlet } from "react-router-dom";
import useLogin from "./components/common/useLogin";

const ProtectedLayout = () => {
  const { login } = useLogin();
  const { DriverID } = { ...login };
  if (!DriverID) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedLayout;
